<template>
  <div class="container flex items-center justify-center h-full px-4 py-8 mx-auto text-3xl font-thin lg:px-8 text-primary xl:text-6xl">{{ $t('notReady.comingSoon') }}</div>
</template>

<script>
export default {};
</script>

<style></style>
